import { __esmMin as e } from "../_virtual/_rolldown/runtime.es.js";
import t, { init_circular_progress as n } from "../assets/icons/circular_progress.svg_raw.es.js";
import r, { init_cortexSparkIcon as i } from "../assets/icons/cortexSparkIcon.svg_raw.es.js";
import a, { init_lock_keyhole as o } from "../assets/icons/lock-keyhole.svg_raw.es.js";
// libs/ui-lib/src/lib/iconAssets.ts
function s(e) {
	return e in l;
}
function c(e) {
	if (e in u) return u[e];
}
var l, u, d = e((() => {
	n(), i(), o(), l = {
		"circular-progress": {
			name: "circular-progress",
			path: "@/assets/icons/circular_progress.svg",
			type: "svg",
			inlineable: !0
		},
		"cortex-spark-icon": {
			name: "cortex-spark-icon",
			path: "@/assets/icons/cortexSparkIcon.svg",
			type: "svg",
			inlineable: !0
		},
		"lock-keyhole": {
			name: "lock-keyhole",
			path: "@/assets/icons/lock-keyhole.svg",
			type: "svg",
			inlineable: !0
		}
	}, u = {
		"circular-progress": t,
		"cortex-spark-icon": r,
		"lock-keyhole": a
	};
}));
d();
export { c as getIconSvgContent, s as hasIconAsset, l as iconAssets, u as iconSvgContent, d as init_iconAssets };
